import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** SVG path for the lit part of a moon of radius r centred on (0, 0). */
export const moonLitPath = (fraction: number, waxing: boolean, r: number): string => {
    const k = Math.min(1, Math.max(0, fraction))
    const rx = Math.max(0.001, r * Math.abs(1 - 2 * k))
    const gibbous = k > 0.5

    if (waxing) {
        return `M 0 ${-r} A ${r} ${r} 0 0 1 0 ${r} A ${rx} ${r} 0 0 ${gibbous ? 1 : 0} 0 ${-r} Z`
    }

    return `M 0 ${-r} A ${r} ${r} 0 0 0 0 ${r} A ${rx} ${r} 0 0 ${gibbous ? 0 : 1} 0 ${-r} Z`
}

interface MoonGlyphProps {
    fraction: number
    waxing: boolean
    className?: string
}

export const MoonGlyph = ({ fraction, waxing, className }: MoonGlyphProps): ReactNode => {
    return (
        <svg viewBox='-10 -10 20 20' aria-hidden className={cn('shrink-0', className)}>
            <circle r='8' fill='var(--c-ink-4)' stroke='var(--c-hair-2)' strokeWidth='0.6' />
            {fraction > 0.01 && <path d={moonLitPath(fraction, waxing, 8)} fill='var(--c-star)' />}
        </svg>
    )
}
